import api from "./api";

const collegeService = {
    getAll: (params) => api.get("/colleges", { params }),
    getPublic: () => api.get("/colleges/public"),
    getById: (id) => api.get(`/colleges/${id}`),
    create: (data) => api.post("/colleges", data),
    update: (id, data) => api.put(`/colleges/${id}`, data),
    remove: (id) => api.delete(`/colleges/${id}`),
};

export default collegeService;